import { Trans } from '@lingui/react'
import './ErxSumBox.scss'
import { CartEntryItemERxV2PriceLabelInfoEnum } from '@redteclab/api/clients/bully'
import type { FunctionComponent } from 'react'

import type { CartControllerGroupEntryERx } from 'types/api/cart'
import { ERxMedicationType } from 'views/consts/cart'

interface ErxSumBoxProps {
  groupEntriesERx: CartControllerGroupEntryERx
}

const getMedicationTypeTranslation = (type: ERxMedicationType) => {
  switch (type) {
    case ERxMedicationType.FREETEXT:
      return <Trans id="product.erx.medicationType.freetext" />
    case ERxMedicationType.ACTIVE_SUBSTANCE:
      return <Trans id="product.erx.medicationType.activeSubstance" />
    case ERxMedicationType.COMPOSITE:
      return <Trans id="product.erx.medicationType.compositeRegulation" />
    default:
      return ''
  }
}

const nonPznMedicationTypes = new Set([
  ERxMedicationType.FREETEXT,
  ERxMedicationType.ACTIVE_SUBSTANCE,
  ERxMedicationType.COMPOSITE,
])

const ErxSumBox: FunctionComponent<ErxSumBoxProps> = ({
  groupEntriesERx,
}: ErxSumBoxProps) => {
  const filteredMedicationTypes = Array.from(
    new Set(
      groupEntriesERx.items
        .map(item => item.medicationType)
        .filter(type => nonPznMedicationTypes.has(type))
    )
  )

  const hasCallInAnyCase = groupEntriesERx.items.some(
    item =>
      item.priceLabelInfo === CartEntryItemERxV2PriceLabelInfoEnum.CallInAnyCase
  )

  return (
    <ul className="a-ErxSumBox" data-qa-id="erx-sum-box">
      {filteredMedicationTypes.map(type => {
        return (
          <li className="a-ErxSumBox__list" key={type}>
            <p className="a-ErxSumBox__list--text">
              {hasCallInAnyCase ? (
                <Trans id="cart.sumBox.erx.expiredRecipe" />
              ) : (
                getMedicationTypeTranslation(type)
              )}
            </p>
            <p className="a-ErxSumBox__list--text u-text-align--right">
              <Trans id="cart.sumBox.erx.priceStillUnknown" />
            </p>
          </li>
        )
      })}
    </ul>
  )
}

export default ErxSumBox
